import '../scss/main.scss';

import ProjectOffer from './project-offer';

window.addEventListener('DOMContentLoaded', () => {
	let projectOfferContainers = document.querySelectorAll('.project-offer-wrapper');

	if (projectOfferContainers.length < 1) {
		return;
	}

	projectOfferContainers = [].slice.call(projectOfferContainers);

	projectOfferContainers.forEach(container => {
		new ProjectOffer(
			container,
			{
				projects: ajax_url_module_project_offer_get_projects
			}
		);
	});
});